export const update = {
  updateSuccessfully: 'Update machine successfully!',
}
